<template>
  <div class="bigbox" >
      <img-app :style="backImg" :contactTitle="contact.name" :contactList="contact.contactlist" ></img-app>
      <div class="main"  >
          <div class="newsDetail_title text-center ft18 color18191a fontWeight">{{oData.newsDetail_title}}</div>
          <div class="newsDetail_content lh32" v-html="oData.content"></div>
          <div class="newsDetail_apar lh32">{{oData.apartment}}</div>
          <div class="newsDetail_time lh32">{{oData.time}}</div>
          <div class="h88"></div>
      </div>
    </div>
</template>

<script>
 import imgApp from '@/components/common/imgApp.vue'; 

 import bus from '@/assets/js/bus'
export default {
  name: 'latestNews',
  data () {
    return {
      backImg:{
        background:'url(static/images/latestNew.png) no-repeat top center'
      },
      contact:{
        name:'最新资讯',
        contactlist:[{listTitle:"公司新闻"},{listTitle:"产品发布"}]
      },
      oData:{
        //newsid:1,
        /*newsDetail_title:'《春节放假通知》',
        content:'<span class="color18191a">全体员工：</span><br />又是一年新来到！惜别2017，又迎来了充满希望、机遇和挑战的2018年！正值中国传统的节日“春节”来临，再次向广大职工朋友拜个早年！预祝大家新春快乐！财源广进！<br />为了欢庆传统的新春佳节，根据国家规定和我司的具体情况，经研究，我司春节放假7天，元月15至2月21日-22日上班。',
        apartment:'【行政部】',
        time:'2018.5.10'*/
      },
      //模拟数据
      testData:[
        {newsid:1,content:{ newsDetail_title:'《春节放假通知》',
        content:'<span class="color18191a">全体员工：</span><br />又是一年新来到！惜别2017，又迎来了充满希望、机遇和挑战的2018年！正值中国传统的节日“春节”来临，再次向广大职工朋友拜个早年！预祝大家新春快乐！财源广进！<br />为了欢庆传统的新春佳节，根据国家规定和我司的具体情况，经研究，我司春节放假7天，元月15至2月21日-22日上班。',
        apartment:'【行政部】',
        time:'2018.5.10'}},
        {newsid:2,content:{ newsDetail_title:'《春节放假通知》22',
        content:'<span class="color18191a">全体员工：</span><br />又是一年新来到！惜别2017，又迎来了充满希望、机遇和挑战的2018年！正值中国传统的节日“春节”来临，再次向广大职工朋友拜个早年！预祝大家新春快乐！财源广进！<br />为了欢庆传统的新春佳节，根据国家规定和我司的具体情况，经研究，我司春节放假7天，元月15至2月21日-22日上班。',
        apartment:'【行政部】',
        time:'2018.5.10'}},
      ],
      current_id:null,
      false:false
    }
  },
  methods:{
    //得到id
   getStatus (urlStr) {
      var urlStrArr = urlStr.split('/')
      console.log(urlStrArr)
      return urlStrArr[urlStrArr.length - 1]
    },
    onScroll(){
      bus.$emit('navChange',0); 
     }
  },
  components:{
    "img-app":imgApp,
    
  },
  beforeCreate(){
    bus.$emit('NoshowAnimate',this.flase)
  },
  created(){
    //console.log(this.getStatus(this.$route.path))  从url得到详细的id
    //console.log(this.$route.params.id) 从路由得到详细的id
    this.current_id=this.$route.params.id;
    this.testData.forEach((item,index,arr)=>{
      //console.log(item.newsid)
      if(this.current_id==item.newsid){
        this.oData=item.content;
      }
    })
    console.log(this.$route.path)
  },
   watch: {
   '$route' (to, from) {
     console.log(to.params.id)
   }
 },
 mounted: function () {
    this.$nextTick(function () {
      window.addEventListener('scroll', this.onScroll)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
  width: 1172px;
  margin:4px auto 0;
  padding-left: 200px;
  color:#84898c;
}
.newsDetail_title{
  padding-top:78px;
  padding-bottom: 49px;
}
.newsDetail_content{
  padding-bottom: 58px;
}
</style>




// WEBPACK FOOTER //
// src/components/latestNewsDetail.vue